import {cloneDeep} from "lodash";
import {getString, resetObjectValues} from "Core/helpers/data";
import {CustomerCustomFieldsItemDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {CustomerCustomFieldsItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new CustomerCustomFieldsItemDataObject(
		getString(result, 'customerCustomFieldId'),
		getString(result, 'name'),
		getString(result, 'description'),
		getString(result, 'type'),
	);

	return result;
}

/**
 * Get output data from input data
 * @param {CustomerCustomFieldsItemDataObject} inputData - Input data.
 * @return {Object}
 */
export const output = inputData => {
	let result = cloneDeep({
		customerCustomFieldId: inputData.id,
		name: inputData.name,
		description: inputData.description,
		type: inputData.dataType,
	});

	// Set proper empty values expected by the API
	result = resetObjectValues(result);

	return result;
}